import {
  AssetCreateRequest,
  AssetInputs,
  AssetUpdateRequest,
} from '../../../types/app/asset.types';

export const convertDataFromInputToCreateRequest = (data: AssetInputs): AssetCreateRequest => ({
  assetType: data.assetType,
  groupId: data.groupId ? data.groupId : undefined,
  name: data.name,
  influxMachineName: data.influxMachineName,
  parentAssetId: data.parentAssetId ? data.parentAssetId : null,
  useWithDashboards: data.useWithDashboards,
  grafanaFolderUId: data.grafanaFolderUId,
  hydraMachineNumber: data.hydraMachineNumber,
  loadPlanFromHydra: data.loadPlanFromHydra,
  loadPlanFromHydraMultiplicity: data.loadPlanFromHydraMultiplicity,
  loadPlanFromHydraMultiple: data.loadPlanFromHydraMultiple,
  unitOverride: data.unitOverride,
});

export const convertDataFromInputToUpdateRequest = (data: AssetInputs): AssetUpdateRequest => ({
  id: data.id!,
  groupId: data.groupId ? data.groupId : undefined,
  assetType: data.assetType,
  name: data.name,
  influxMachineName: data.influxMachineName,
  parentAssetId: data.parentAssetId ? data.parentAssetId : null,
  useWithDashboards: data.useWithDashboards,
  grafanaFolderUId: data.grafanaFolderUId,
  hydraMachineNumber: data.hydraMachineNumber,
  loadPlanFromHydra: data.loadPlanFromHydra,
  loadPlanFromHydraMultiplicity: data.loadPlanFromHydraMultiplicity,
  loadPlanFromHydraMultiple: data.loadPlanFromHydraMultiple,
  unitOverride: data.unitOverride,
});
